import { useFxRate } from 'hooks/useFxRate';

import { BlindingDots } from '@atoms/BlindingDots/BlindingDots';

import { ExchangeRateDisplay } from './ExchangeRateDisplay';
import { ExchangeText } from './ExchanteText';

export function ExchangeRate({
  payCurrency,
  buyCurrency,
  amountToConvert
}: {
  payCurrency: string;
  buyCurrency: string;
  amountToConvert: number;
}) {
  const { fx, loading, error, rateUnavailable } = useFxRate({
    payCurrencyCode: payCurrency,
    buyCurrencyCode: buyCurrency
  });

  return (
    <div className="flex flex-col">
      <div
        className="h-full font-bold text-content-brand"
        data-testid="resultsText"
      >
        {loading ? (
          <BlindingDots />
        ) : rateUnavailable ? (
          'FX Rate not supported.'
        ) : error ? (
          'Exchange rate is not available.'
        ) : (
          <ExchangeRateDisplay
            amountToConvert={amountToConvert}
            exchangeRateData={fx}
          />
        )}
      </div>
      <div
        className="text-xs text-content-subtle"
        data-testid="updateScheduleText"
      >
        {loading ? (
          <BlindingDots />
        ) : (
          <ExchangeText
            rateUnavailable={rateUnavailable}
            retrievalTime={fx?.utcTime}
          />
        )}
      </div>
    </div>
  );
}
